'use client';

import { PortalModal, usePortalContext } from '@cloai/uikit';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { PORTALS } from '@/.constants/portals';
import { Header } from '@/src/components/Header';
import { SubscribersBlock } from '@/src/components/user/SubscribersBlock';
import {
  useProfileContext,
  useMobileContext,
  useSubscriptionsForMeContext,
} from '@/src/providers';

const styles = {
  portal:
    '!h-dvh !max-h-none !min-h-dvh !rounded-none !bg-none !bg-fill-menu !p-0',
  head: 'flex gap-2 items-center mb-4',
  headWrap:
    'absolute top-0 left-0 right-0 z-20 py-2 px-5 flex justify-center bg-fill-menu dark:bg-fill-menu bg-fill-menuBg',
  innerWrap: 'shrink-0 bg-fill-menu px-5 pt-16',
};

export const MySubscriptionsPortal: FC = () => {
  const profile = useProfileContext();
  const { closePortal } = usePortalContext();
  const t = useTranslations('ProfilePage');
  const { isMobiles } = useMobileContext();
  const { mySubscriptions } = useSubscriptionsForMeContext();

  if (!profile) {
    return null;
  }

  return (
    <PortalModal
      portalId={PORTALS.MySubscriptions}
      className={styles.portal}
      noClose
    >
      <div className="h-full relative">
        <div className={twMerge(styles.headWrap, isMobiles && 'pt-[100px]')}>
          <Header isCloseButton onClickCloseButton={closePortal} />
        </div>
        <div
          className={twMerge(
            'h-full overflow-y-auto',
            isMobiles && 'pt-[100px]',
          )}
        >
          <div className={styles.innerWrap}>
            <SubscribersBlock
              subscribers={mySubscriptions}
              title={t('subscriptions')}
            />
          </div>
        </div>
      </div>
    </PortalModal>
  );
};
